import { includeGenericModule } from "@/shared/vuex_generic_module.js";
import * as actions from "./actions.js";

export default () =>
  includeGenericModule({
    namespaced: true,
    actions,
  });
